import React, { Fragment } from 'react';

export default function GhostContainer({ children, theme }) {
  if (children.length === 0) {
    return (
      <div className="col-12 message-box" style={{ textAlign: 'center' }}>
        <p style={{ padding: '10% 0' }}> No {theme} to show.</p>
      </div>
    );
  }
  return <Fragment>{children}</Fragment>;
}



// WEBPACK FOOTER //
// ./src/screens/Places/GhostContainer.jsx